<template>
  <main-layout :selectedMenu="'home'">
    <!--<div class="signbanner"> <img src="/static/bannerTimeOut.jpg" /> </div>
    <div class="signNavs">
      <ul>
        <li class="active"><a> 赛事概览 </a></li>
        <li><a> 历届获奖作品 </a></li>
        <li><a> 奖项设置 </a></li>
        <li><a> 参赛说明 </a></li>
      </ul>
    </div>-->

    <div class="writeInfor">
      <form class="formtabs">
        <div class="compwrite">填写报名信息</div>
        <input
          class="writestyle"
          type="text"
          placeholder="团队名称或个人姓名"
          v-model="userName"
          @blur="checkValue(2,$event,1)"
        />
        <div class="error" v-if="isFlag1">姓名不能为空</div>
        <div class="useremail">
          <input
            class="writestyle"
            type="text"
            placeholder="邮箱"
            v-model="userEmail"
            @blur="checkValue(1,$event)"
          />
          <!--<button>立即验证</button><button>立即验证</button>-->
          <div class="error" v-if="isFlag2">邮箱格式不正确</div>
        </div>
        <div class="phonenumber">
          <el-select
            v-model="areaCode"
            filterable
            remote
            :remote-method="getAreaCodeList"
            placeholder="请选择"
            class="elselect leftside"
            style="width: 76px;"
          >
            <el-option
              v-for="(item,index) in areaCodeList"
              :key="index"
              :value="item.areaCode"
              :label="item.areaCode"
              v-if="index < 500"
            >
              <div>
                {{item.title}}
                <span class="areacode">{{item.areaCode}}</span>
              </div>
            </el-option>
          </el-select>
          <input
            class="writestyle"
            type="text"
            placeholder="手机号码"
            v-model="userPhone"
            @blur="checkValue(2,$event,3)"
          />
          <div class="error" v-if="isFlag3">手机格式不正确</div>
          <span class="sendrightbtns" @click="sendSms">{{buttonText}}</span>
        </div>
        <div style="margin-top:40px;">
          <input
            class="writestyle"
            type="text"
            placeholder="验证码"
            v-model="phoneCode"
            @blur="checkValue(4,$event)"
          />
          <div class="error" v-if="isFlag4">验证码不正确</div>
        </div>
        <div class="agreements">
          <input type="checkbox" v-model="isAgree" />
          <span @click="agreePro">
            我已同意
            <span>本次大赛参加规则等所有条款</span>
          </span>
        </div>
        <a class="submitbtn" @click="goMatchUser()">确认报名</a>
      </form>

      <div v-if="provision" class="fixprovision"></div>
      <div
        v-if="provision"
        class="provisioncontent"
        :class="{animated:isAnimated,bounceInDown:isBounceInDown}"
      >
        <p class="header">赛事规则</p>
        <p>参赛作品须为参赛者个人独立完成或团队合作完成的原创作品，不得抄袭他人作品，并确保绝不涉及或侵犯第三方的知识产权。</p>
        <p>1.保证作品合法性，遵守国家有关法律、行政法规的规定，符合公共道德价值、行业规范等要求，意识形态及政治观点不能与中华人民共和国法律相抵，不能含有色情、暴力、封建迷信、诱导犯罪、侮辱诽谤、破坏民族团结等不利于社会良性发展的因素。因项目团队行为、个人参赛者行为、作品引发的全部法律责任，由创作者（参赛者）独立承担。</p>
        <p>2.所有提交作品的知识产权归项目团队或个人参赛者所有。「2019“现未来”科技艺术之星奖」组委会可将作品用于本次活动及相关的宣传品制作；用于指定及授权媒体发布；用于颁奖典礼、展览等相关落地活动。「2019“现未来”科技艺术之星奖」组委会在对优秀作品投入孵化资源、进行商业开发前，应由双方协商一致并签订书面协议。</p>
        <p>3.参赛者需同意在网站（MANA）上公开展示参赛作品。网站中的全部参赛作品禁止下载及盗用，不得转载。</p>
        <p>4.本次大赛的主办方拥有最终解释权，报名的参赛者即表示同意所有比赛相关的条款及细则。</p>
        <a @click="closeSureBtn" class="surebtn">确定</a>
      </div>
    </div>
  </main-layout>
</template>

<script>
import "./css/lifePz.css";
import MainLayout from "@/layouts/MainLayout";
export default {
  name: "signupPz",
  data() {
    return {
      //入围作品list
      userName: "",
      userEmail: "",
      userPhone: "",
      phoneCode: "",
      isAgree: false,
      isFlag1: false,
      isFlag2: false,
      isFlag3: false,
      isFlag4: false,
      buttonText: "发送验证码",
      sendFlag: true,
      sessionId: "",
      areaCode: "",
      areaCodeList: [],
      provision: false,
      isAnimated: false,
      isBounceInDown: false
    };
  },
  methods: {
    agreePro() {
      this.provision = true;
      this.isAnimated = true;
      this.isBounceInDown = true;
    },
    closeSureBtn() {
      this.provision = false;
      this.isAnimated = false;
      this.isBounceInDown = false;
    },

    getAreaCodeList(val) {
      let config = {
        loading: false,
        params: {
          keyWords: val,
          pageSize: 500,
          pageIndex: 1,
          orderBy: "areaCode"
        }
      };

      this.$http.get("/api/areacode/areaCodeList", config).then(response => {
        this.areaCodeList = response.data.list;
        this.areaCode = "86";
      });
    },
    checkValue(type, e, num) {
      let val = "";
      //debugger
      switch (type) {
        case 1:
          let mailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
          this.isFlag2 = !mailReg.test(this.userEmail);
          break;
        case 2:
          if (e.target == null) {
            val = e;
          } else {
            val = e.target.value;
          }
          if (val == null || val == "") {
            this["isFlag" + num] = true;
            //this.isFlag1 = true;
          } else {
            this["isFlag" + num] = false;
            //this.isFlag1 = false;
          }
          break;
        case 3:
          let regexp =
            "^(((\\+\\d{2}-)?0\\d{2,3}-\\d{7,8})|((\\+\\d{2}-)?(\\d{2,3}-)?([1][3,4,5,7,8][0-9]\\d{8})))$";
          var reg = new RegExp(regexp);
          this.isFlag3 = !reg.test(this.userPhone);
          break;
        case 4:
          if (e.target == null) {
            val = e;
          } else {
            val = e.target.value;
          }
          if (val == null || val == "") {
            this.isFlag4 = true;
          } else {
            this.isFlag4 = false;
          }
          break;
      }
    },
    goMatchUser() {
      if (this.checkValue(2, this.userName)) {
        return;
      } else if (this.checkValue(1, this.userEmail)) {
        return;
      } else if (this.checkValue(2, this.userPhone)) {
        return;
      } else if (this.checkValue(4, this.phoneCode)) {
        return;
      }

      if (this.isFlag1 || this.isFlag2 || this.isFlag3 || this.isFlag4) {
        return;
      }

      if (!this.isAgree) {
        this.$message("未选择大赛规则");
        return;
      }
      let params = {};
      if (this.areaCode == null || this.areaCode == "") {
        params = {
          userId: -1,
          matchId: this.$query.matchId,
          userName: this.userName,
          userEmail: this.userEmail,
          userPhone: this.userPhone,
          sessionId: this.sessionId,
          phoneCode: this.phoneCode
        };
      } else {
        params = {
          userId: -1,
          matchId: this.$query.matchId,
          userName: this.userName,
          userEmail: this.userEmail,
          userPhone: `+${this.areaCode}${this.userPhone}`,
          sessionId: this.sessionId,
          phoneCode: this.phoneCode
        };
      }

      this.$http.post("/api/match/user/create", params).then(response => {
        if (response.code == "400") {
          this.$message({
            message: response.message,
            type: "error"
          });
        } else {
          this.$store.dispatch("setAccountUser", {
            ...this.$store.state.accountUser,
            phone: params.userPhone
          });
          localStorage.setItem(
            "userAccount",
            JSON.stringify(this.$store.state.accountUser)
          );
          //跳转到上传视频页面
          this.$router.push({
            path: "/UpVideo?matchId=" + this.$query.matchId
          });
        }
      });
    },
    sendSms(e) {
      if (!this.sendFlag) return;
      if (this.areaCode == null || this.areaCode == "") {
        this.$message("请选择国家");
        return;
      }

      let areaCode = "";
      if (this.areaCode == "86") {
        areaCode = "86";
      } else {
        areaCode = this.areaCode;
      }

      if (this.phone != "") {
        let params = {};

        if (this.areaCode == null || this.areaCode == "") {
          params = { phone: `${this.userPhone}` };
        } else {
          params = { phone: `+${this.areaCode}${this.userPhone}` };
        }
        this.$http.post("/api/customer/sendCode", params).then(response => {
          if (response.code == "OK") {
            this.$message("验证码已发送");
            this.timeDown();
          } else {
            this.$message(response.message);
          }
        });
      }
    },
    timeDown() {
      let time = 60;
      let $this = this;
      let interval = setInterval(() => {
        time--;
        $this.buttonText = `已发送(${time}s)`;
        if (time === 0) {
          clearInterval(interval);
          $this.buttonText = "重新获取";
          $this.sendFlag = true;
          return;
        }
        $this.sendFlag = false;
      }, 1000);
    }
  },
  created() {
    //获取区域号码
    this.getAreaCodeList("");
  }
};
</script>

<style scoped>
.writestyle + .error {
  position: relative;
  top: 5px;
  height: 19px;
  color: #ff0000;
  text-align: left;
  font-size: 14px;
  border: none;
}
.phonenumber .leftside {
  float: left;
}
.phonenumber .el-select .el-input.is-focus .el-input__inner {
  width: 100%;
  border: none;
  border-color: transparent !important;
}
.agreements {
  cursor: pointer;
}

.fixprovision {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.5);
}
.provisioncontent {
  position: fixed;
  width: 536px;
  height: 563px;
  z-index: 100;
  top: 50%;
  left: 50%;
  color: #999;
  font-size: 12px;
  padding: 30px;
  line-height: 20px;
  border-radius: 5px;
  margin: -281px 0 0 -268px;
  box-sizing: border-box;
  background-color: #fff;
}
.provisioncontent .header {
  width: 476px;
  height: 25px !important;
  color: #000;
  font-size: 25px;
  text-align: center;
  margin: 20px 0 30px 0;
}
.provisioncontent .header ~ p {
  line-height: 26px;
}
.provisioncontent .surebtn {
  display: block;
  width: 140px;
  height: 35px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 35px;
  border-radius: 3px;
  cursor: pointer;
  margin: 40px auto 0;
  background-color: #005ffe;
}
</style>



// WEBPACK FOOTER //
// src/pages/match/signupPz.vue